import script from "./PDFilterSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./PDFilterSidebar.vue?vue&type=script&setup=true&lang=js"

import "./PDFilterSidebar.vue?vue&type=style&index=0&id=ecff756e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecff756e"]])

export default __exports__